module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "cold-start-step-1.f9e81c40.png" + "?" + Date.now();